import { jsx as f } from "react/jsx-runtime";
import { i as m } from "../../core-DVmjA3_O.js";
import "../../type-Dku6Xzl6.js";
function l(o) {
  const {
    data: r,
    keySelector: s,
    renderer: i,
    rendererParams: a
  } = o;
  return m(r) ? null : r.map(
    (e, t) => {
      const n = s(e, t), d = a(n, e, t, r);
      return /* @__PURE__ */ f(
        i,
        {
          ...d
        },
        String(n)
      );
    }
  );
}
export {
  l as default
};
